import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import type { CompanyInfoRootState } from './companyInfoState'

export const useCompanyInfoAccountId = ({
  product,
  cloud,
}: {
  product: string
  cloud: string
}) => {
  const { accountId: accountIdFromParams } = useParams<{ accountId: string }>()

  return useSelector((state: CompanyInfoRootState) => {
    if (accountIdFromParams) {
      return accountIdFromParams
    }

    const accounts = state.accountSelection?.availableAccounts
    const accountData = (Array.isArray(accounts) ? accounts : []).filter(
      account => account?.product?.toLowerCase() === product
    )
    return accountData?.find(account => account?.cloud === cloud)?.id || ''
  })
}
